<template><section><template>
<h3>幻灯片</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-carousel>
  <n3-slide key="1">
    <img class="slide-img" src="http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg">
    <div class="carousel-caption">
      <h3>Slide #1</h3>
      <p>xxxxxxxxxxxx</p>
    </div>
  </n3-slide>
  <n3-slide key="2">
    <img class="slide-img" src="http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg">
    <div class="carousel-caption">
      <h3>Slide #2</h3>
      <p>xxxxxxxxxxxx</p>
    </div>
  </n3-slide>
  <n3-slide key="3">
    <img class="slide-img" src="http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg">
    <div class="carousel-caption">
      <h3>Slide #3</h3>
      <p>xxxxxxxxxxxx</p>
    </div>
  </n3-slide>
</n3-carousel>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-carousel</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-slide</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"slide-img"</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"carousel-caption"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>Slide #1<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxxxxxxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-slide</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-slide</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"slide-img"</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"carousel-caption"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>Slide #2<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxxxxxxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-slide</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-slide</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"slide-img"</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"carousel-caption"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>Slide #3<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxxxxxxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-slide</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-carousel</span>&gt;</span>
</code></pre>
<div class="bs-example">
  <n3-carousel>
  <n3-slide v-for="item in list" :key="index">
    <img class="slide-img" :src="item.img">
    <div class="carousel-caption">
      <h3>{{item.title}}</h3>
      <p>{{item.content}}</p>
    </div>
  </n3-slide>
  </n3-carousel>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-carousel</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-slide</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in list"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"slide-img"</span> <span class="hljs-attr">:src</span>=<span class="hljs-string">"item.img"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"carousel-caption"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>{{item.title}}<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{item.content}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-slide</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-carousel</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">  <span class="hljs-keyword">const</span> list = [
    {
      <span class="hljs-attr">id</span>: <span class="hljs-string">"7"</span>,
      <span class="hljs-attr">title</span>: <span class="hljs-string">"图片新闻测试"</span>,
      <span class="hljs-attr">img</span>: <span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>,
      <span class="hljs-attr">create_at</span>: <span class="hljs-string">"2017-05-05"</span>
    },
    {
      <span class="hljs-attr">id</span>: <span class="hljs-string">"8"</span>,
      <span class="hljs-attr">title</span>: <span class="hljs-string">"图片新闻2"</span>,
      <span class="hljs-attr">img</span>: <span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>,
      <span class="hljs-attr">create_at</span>: <span class="hljs-string">"2017-05-05"</span>
    },
    {
      <span class="hljs-attr">id</span>: <span class="hljs-string">"7"</span>,
      <span class="hljs-attr">title</span>: <span class="hljs-string">"图片新闻测试"</span>,
      <span class="hljs-attr">img</span>: <span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>,
      <span class="hljs-attr">create_at</span>: <span class="hljs-string">"2017-05-05"</span>
    },
    {
      <span class="hljs-attr">id</span>: <span class="hljs-string">"8"</span>,
      <span class="hljs-attr">title</span>: <span class="hljs-string">"图片新闻2"</span>,
      <span class="hljs-attr">img</span>: <span class="hljs-string">"http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg"</span>,
      <span class="hljs-attr">create_at</span>: <span class="hljs-string">"2017-05-05"</span>
    }
  ]

  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">list</span>: []
      }
    },
    <span class="hljs-attr">methods</span>: {
      updateList () {
        setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
          <span class="hljs-keyword">this</span>.list.push.apply(<span class="hljs-keyword">this</span>.list, list)
        })
      }
    },
    mounted () {
      <span class="hljs-keyword">this</span>.updateList()
    }
  }
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>indicators</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否显示控制点</td>
</tr>
<tr>
<td>controls</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否显示箭头</td>
</tr>
<tr>
<td>interval</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">5000</code></td>
<td>自动切换时间(小于等于0时不自动切换)</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>
<style scoped>
.slide-img{
  height:400px!important;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);
}
@media screen and (min-width: 768px) {
  .carousel-caption {
    right: 20%;
    left: 20%;
    padding-bottom: 30px;
  }
}
</style>
<script>
  const list = [
    {
      id: "7",
      title: "图片新闻测试",
      img: "http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg",
      create_at: "2017-05-05"
    },
    {
      id: "8",
      title: "图片新闻2",
      img: "http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg",
      create_at: "2017-05-05"
    },
    {
      id: "7",
      title: "图片新闻测试",
      img: "http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg",
      create_at: "2017-05-05"
    },
    {
      id: "8",
      title: "图片新闻2",
      img: "http://www.photops.com/Photo/UpPhoto2010/201106/2011060409214653.jpg",
      create_at: "2017-05-05"
    }
  ]

  export default {
    data () {
      return {
        list: []
      }
    },
    methods: {
      updateList () {
        setTimeout(() => {
          this.list.push.apply(this.list, list)
        })
      }
    },
    mounted () {
      this.updateList()
    }
  }
</script>


// WEBPACK FOOTER //
// n3CarouselDocs.md?75e0ded0